import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-89da1f4a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-background w-full" }
const _hoisted_2 = { class: "container py-8" }
const _hoisted_3 = { class: "flex flex-row justify-end w-full" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
  })
], -1))
const _hoisted_5 = { class: "flex flex-col w-full space-x-5 p-4 font-normal" }
const _hoisted_6 = { class: "w-full flex flex-row justify-center" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "flex flex-row justify-center w-full" }
const _hoisted_9 = { class: "" }
const _hoisted_10 = { class: "main-container w-container" }
const _hoisted_11 = {
  key: 0,
  class: "w-layout-grid grid-7"
}
const _hoisted_12 = {
  "data-w-id": "c8956ecb-cf16-419e-de96-9a8724ca8982",
  class: "large-heading section-title-price",
  style: {"opacity":"1"}
}
const _hoisted_13 = {
  key: 0,
  class: "text-primary-purple"
}
const _hoisted_14 = {
  key: 1,
  class: "w-tabs"
}
const _hoisted_15 = { class: "p-4" }
const _hoisted_16 = { class: "flex font-semibold text-sm cursor-pointer" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Monthly", -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "block" }, "Yearly", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "(2 months free)", -1))
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = { key: 2 }
const _hoisted_25 = { class: "text-primary-purple text-center text-reguular" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" Monthly: ")
const _hoisted_27 = { class: "uppercase" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = {
  key: 3,
  class: "text-primary-purple text-center text-reguular"
}
const _hoisted_30 = { class: "uppercase" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { class: "text-primary-purple text-center text-reguular" }
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" +")
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" + ")
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" of yearly total comp/hire ")
const _hoisted_37 = { class: "mt-18" }
const _hoisted_38 = ["onClick"]
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center justify-center p-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "" }, "Get Started")
], -1))
const _hoisted_40 = [
  _hoisted_39
]
const _hoisted_41 = { class: "badge pricing-badge bg-primary-3" }
const _hoisted_42 = /*#__PURE__*/_createStaticVNode("<div class=\"flex flex-row justify-center w-full p-1 mt-8 mb-8\" data-v-89da1f4a><p class=\"text-justify text-gray-500\" data-v-89da1f4a> By submitting your payment information you agree to our <a href=\"https://hiring.axelerate.io/terms-and-conditions\" target=\"”_blank”\" class=\"text-primary cursor-pointer\" data-v-89da1f4a>Terms and Conditions</a>, <a href=\" https://hiring.axelerate.io/privacy-policy\" target=\"”_blank”\" class=\"text-primary cursor-pointer\" data-v-89da1f4a>Privacy Policy</a>, and <a href=\"https://hiring.axelerate.io/terms-of-service\" target=\"”_blank”\" class=\"text-primary cursor-pointer\" data-v-89da1f4a>Terms of Service</a>. </p></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Button, {
          variant: "contained",
          onOnClick: _ctx.logOut,
          label: "Logout"
        }, {
          startIcon: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["onOnClick"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.buildContentTitle, (item, i) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(item.generalStyle),
            key: `item-title-${i + 1}`
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("img", {
                src: item.src,
                class: "w-72"
              }, null, 8, _hoisted_7)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", {
                class: _normalizeClass([item.styleSpan, "line"])
              }, _toDisplayString(item.text), 3)
            ])
          ], 2))
        }), 128))
      ]),
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_Loading, {
            key: 0,
            active: _ctx.isLoading,
            "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isLoading) = $event)),
            "can-cancel": false,
            loader: "spinner",
            color: "#8908F9",
            width: 128,
            height: 128,
            opacity: 0.5,
            "is-full-page": true
          }, null, 8, ["active", "opacity"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          (!_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupDataPrices, (price, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "boxed pricing-plan shadow-large",
                    key: i
                  }, [
                    _createElementVNode("div", null, [
                      _createElementVNode("h5", _hoisted_12, _toDisplayString(price.label), 1),
                      (price.data.length > 1)
                        ? (_openBlock(), _createElementBlock("h5", _hoisted_13, " Cost: "))
                        : _createCommentVNode("", true),
                      (price.data.length > 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _createElementVNode("div", _hoisted_15, [
                              _createElementVNode("div", _hoisted_16, [
                                _createElementVNode("div", {
                                  class: _normalizeClass(["w-1/2 border border-primary p-3 rounded-l-3xl flex flex-col justify-center", 
                          !!price.monthlySelected
                            ? ' bg-primary text-white'
                            : 'text-primary'
                        ]),
                                  onClick: ($event: any) => (_ctx.selectPricing(price.data[0], i))
                                }, _hoisted_19, 10, _hoisted_17),
                                _createElementVNode("div", {
                                  class: _normalizeClass(["w-1/2 border p-3 border-primary rounded-r-3xl", 
                          !price.monthlySelected
                            ? 'bg-primary text-white'
                            : 'text-primary'
                        ]),
                                  onClick: ($event: any) => (_ctx.selectPricing(price.data[1], i))
                                }, _hoisted_23, 10, _hoisted_20)
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (price.data.length <= 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                            _createElementVNode("div", _hoisted_25, [
                              _hoisted_26,
                              _createElementVNode("strong", _hoisted_27, "$" + _toDisplayString(_ctx.getAmount(price.data[0].metadata.price)) + " " + _toDisplayString(price.data[0].currency), 1),
                              (_ctx.currency === 'mx')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_28, "+ iva"))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (price.data.length > 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                            _createTextVNode(_toDisplayString(price.typePayment) + ": ", 1),
                            _createElementVNode("strong", _hoisted_30, " $" + _toDisplayString(_ctx.getAmount(price.labelSelected)) + " " + _toDisplayString(price.data[0].currency), 1),
                            (_ctx.currency === 'mx')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_31, "+ iva"))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_32, [
                        _hoisted_33,
                        _hoisted_34,
                        _hoisted_35,
                        _createElementVNode("strong", null, _toDisplayString(price.data[0].metadata.hiring_fee) + "%", 1),
                        _hoisted_36
                      ]),
                      _createElementVNode("div", _hoisted_37, _toDisplayString(price.description), 1)
                    ]),
                    _createElementVNode("button", {
                      class: "space-x-3 btn-filled-sm flex flex-row items-center disabled:opacity-50 justify-center truncate text-base bg-primary rounded-full transition duration-150 ease-in mt-12 text-medium",
                      onClick: ($event: any) => (_ctx.choosePlan(price))
                    }, _hoisted_40, 8, _hoisted_38),
                    _createElementVNode("div", _hoisted_41, [
                      _createElementVNode("div", null, _toDisplayString(price.pill), 1)
                    ])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _hoisted_42
    ])
  ]))
}